'use es6';

import http from 'hub-http/clients/apiClient';
import formatAdsProperties from '../formatters/formatAdsProperties';
export const createGetAllAdsProperties = ({
  httpClient
}) => () => httpClient.get('/ads-list-seg/v1/interactions/list-seg-properties').then(formatAdsProperties);
export const getAllAdsProperties = createGetAllAdsProperties({
  httpClient: http
});